
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comments",
      function () {
        return require("private-next-pages/comments.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comments"])
      });
    }
  